/**
 * Dynamic API URL Configuration
 */

export const getApiBaseUrl = () => {
  // Priority 1: Use environment variable if set during build
  if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim()) {
    console.log("Using API URL from .env:", process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }

  // Priority 2: Determine from window.location (runtime fallback)
  const protocol = window.location.protocol; // http: or https:
  const hostname = window.location.hostname; // localhost, ngrok-free.dev, etc.
  const port = window.location.port; // 3000, 3001, etc.

  console.log("Environment variable not set, determining from window.location");
  console.log(`  Protocol: ${protocol}, Hostname: ${hostname}, Port: ${port}`);

  // If on localhost:3000 or localhost:3001 (local development)
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const apiUrl = "http://localhost:8085/EwSignApi";
    console.log("Detected localhost - using local API:", apiUrl);
    return apiUrl;
  }

  // If on ngrok URL or any other domain
  if (hostname.includes("ngrok")) {
    // For ngrok, construct URL using the same ngrok domain
    // The ngrok server should proxy requests to /EwSignApi
    const apiUrl = `${protocol}//${hostname}/EwSignApi`;
    console.log("Detected ngrok domain - using:", apiUrl);
    return apiUrl;
  }

  // Fallback for other domains (production, staging, etc.)
  const fallbackUrl = `${protocol}//${hostname}${port ? `:${port}` : ""}/EwSignApi`;
  console.log("Using fallback API URL:", fallbackUrl);
  return fallbackUrl;
};

export default getApiBaseUrl;
